import { Box, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useContext, useRef } from 'react';

import { Context } from '../../context';
import { DATA_HOOKS } from '../../dataHooks';
import { SiteSelector, SiteSelectorParent } from '../SiteSelector';

import css from './index.module.scss';

export const SitePickerSection = () => {
  const { t } = useTranslation();
  const { user } = useContext(Context);
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <Box ref={containerRef} className={css.sitePickerWrapper} direction="vertical" paddingTop="SP3">
      <Heading dataHook={DATA_HOOKS.ARTICLE_RIGHT_SIDEBAR_USER_NAME_TITLE} className={css.userNameTitle} size="large">{t('article-page.copilot.user.title', {name: user?.firstName || ''})}</Heading>
      <Text weight="normal" className={css.userNameSubtitle}>{t('article-page.copilot.user.site.picker.title')}</Text>
      <SiteSelector parentElm={containerRef.current} parent={SiteSelectorParent.ArticleRightSideBar} />
    </Box>
  );
};
